import { createSelector } from '@reduxjs/toolkit';
import { Account } from '../@types/account';
import { RootState } from '../rootReducer';

const accountSelector = (state: RootState): Account => state.account;

const getUserId = createSelector(
  [accountSelector],
  (account: Account) => account.businessId,
);

const selectIsSignedIn = createSelector(
  [accountSelector],
  (account: Account) => account.businessId !== 0,
);

const getToken = createSelector(
  [accountSelector],
  (account: Account) => account.accessToken,
);

const getRefreshToken = createSelector(
  [accountSelector],
  (account: Account) => account.refreshToken,
);

export {
  selectIsSignedIn,
  getToken,
  getRefreshToken,
  getUserId  
};
